module.exports = __webpack_public_path__ + "static/media/1 07 profesjonelt.60f7b2f5.mp3";